<template>
  <div class="glossaryItem">
    <div class="letter">
      {{ letter }}
    </div>
    <div class="children">
      <GlossarySubItem
        v-for="(item, index) in props.children"
        :key="index"
        :name="item.word"
        :desc="item.translation"
        :itemIndex="index"
        :keyword="props.keyword"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

import GlossarySubItem from '../GlossarySubItem/index.vue';

const props = defineProps({
  letter: {
    type: String,
    default: '',
  },

  children: {
    type: Array,
    default: () => [],
  },
  keyword: {
    type: String,
    default: '',
  },
});
</script>
<style lang="scss" scoped>
.glossaryItem {
  margin-top: 0.32rem;
  .letter {
    font-family: BMWTypeNext, serif;
    font-size: 0.24rem;
    font-weight: 700;
    line-height: 0.3252rem;
    text-align: left;
  }
  .children {
    margin-top: 0.18rem;
  }
}
</style>
